var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiLaranjaSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2592,
    cy: 10.9672,
    r: 10.2201,
    fill: "#FB6916"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4815 16.1327C14.7273 16.1807 14.9656 16.0203 15.0136 15.7744C15.0616 15.5285 14.9012 15.2903 14.6553 15.2423L14.4815 16.1327ZM5.86837 15.1732C5.62195 15.2184 5.45883 15.4548 5.50404 15.7012C5.54924 15.9477 5.78565 16.1108 6.03206 16.0656L5.86837 15.1732ZM14.6553 15.2423C12.8374 14.8874 11.5197 14.7048 10.2099 14.696C8.89967 14.6872 7.61651 14.8525 5.86837 15.1732L6.03206 16.0656C7.76016 15.7486 8.97809 15.595 10.2038 15.6032C11.4301 15.6115 12.6834 15.7817 14.4815 16.1327L14.6553 15.2423Z",
    fill: "#FBFFFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.44347,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4689,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiLaranjaSlider);
export default __webpack_public_path__ + "static/media/emojiLaranjaSlider.3a82825cff56835276aefab8a4c46a76.svg";
export { ForwardRef as ReactComponent };